const TitleSortAttribute = {
	Supplier: {
		attribute: 'supplier',
		label: 'Imprint / Publisher',
		type: 'string',
	},
	Format: {
		attribute: 'format',
		label: 'Format',
		type: 'string',
	},
	Category: {
		attribute: 'category',
		label: 'Category',
		type: 'string',
	},
	Series: {
		attribute: 'series',
		label: 'Series',
		type: 'string',
	},
	PublishingStatus: {
		attribute: 'publishingStatus',
		label: 'Publishing Status',
		type: 'string',
	},
	PubDate: {
		attribute: 'pubDate',
		label: 'Published Date',
		type: 'date',
		secondaryAttribute: 'onSaleDate',
	},
	Author: {
		attribute: 'author',
		label: 'Author',
		type: 'string',
	},
	Pages: {
		attribute: 'pages',
		label: 'Pages',
		type: 'number',
	},
	OnSaleDate: {
		attribute: 'onSaleDate',
		label: 'On Sale Date',
		type: 'date',
		secondaryAttribute: 'pubDate',
	},
	DigitalUpdatedDate: {
		attribute: 'digitalUpdatedDate',
		label: 'DRC Added Date',
		type: 'date',
	},
	CommunityReviews: {
		attribute: 'reviews',
		label: 'Community Reviews',
		type: 'number',
	},
	CommunityRating: {
		attribute: 'average',
		label: 'Community Ratings',
		type: 'number',
	},
	Sequence: {
		attribute: 'sequence',
		label: 'Sequence',
		type: 'number',
	},
	NetVotes: {
		attribute: 'netVotes',
		label: 'Net Votes',
		type: 'number',
	},
};

export default TitleSortAttribute;
